<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <div class="content-title content-mb-14">
      <span v-if="project.UF_VID_BUDGET === 0">21</span><span v-else>22</span>.
      Дополнительная информация и комментарии
    </div>
    <UFDopInfo></UFDopInfo>
    <div class="content-title content-mb-14">
      <span v-if="project.UF_VID_BUDGET === 0">22</span><span v-else>23</span>.
      Дополнительные документы
    </div>

    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80" colspan="2">№<br /></th>

          <th class="tab-wid-730">Название документа</th>
          <th class="tab-wid-730">Дата отправки</th>
        </tr>
      </thead>
      <p
        v-if="!showDD"
        class="content-title"
        style="padding-left: 35%; width: 100%;"
      >
        Файлы не загружались
      </p>
      <tbody v-if="showDD">
        <tr v-for="(item, index) in FILE_DOCUMENTS_PATH">
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <td class="tab-wid-80"></td>
          <td class="tab-wid-730">
            <a :href="item.FILE" class="doc-link" target="blank">{{
              getFileName(item.UF_USER_FILE_NAME)
            }}</a>
          </td>
          <td class="tab-wid-730">{{ item.UF_DATE_CREATE }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";
import UFDopInfo from "@/components/project/form/partial/UFDopInfo";
export default {
  name: "step6",
  components: {
    UFDopInfo
  },
  props: ["step", "project"],

  data() {
    return {
      siteUrl: "",
      FILE_DOCUMENTS_PATH: [],
      showDD: true
    };
  },
  mounted() {
    this.getDocInfo();
  },
  methods: {
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getDocInfo() {
      ProjectsService.getDocumentESProjects(2845).then(({ data }) => {
        data.FILE_DOCUMENTS_PATH[14373]
          ? (this.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH[14373])
          : (this.showDD = false);
      }, this);
    }
  }
};
</script>

<style scoped></style>
